module.exports = __webpack_public_path__ + "img/pamm-2.f0d0d64-en.80602e63.png";